import type { PlateElementProps } from 'platejs/react'

import type { GenerateContentElement } from '../nodes/GenerateContentElement'

import styles from './GenerateContentElementUI.module.css'

export const GenerateContentElementUI = ({
  children,
  attributes,
}: PlateElementProps<GenerateContentElement>): JSX.Element => {
  return (
    <div {...attributes} className={styles.highlight}>
      <span className="generated-content-value">{children}</span>
    </div>
  )
}
